export const SET_PAYMENT_CONFIG = 'SET_PAYMENT_CONFIG';
export const SET_PAYMENT_RESPONSE = 'SET_PAYMENT_RESPONSE';
export const SET_PAYMENT_ADDITIONAL_DETAILS = 'SET_PAYMENT_ADDITIONAL_DETAILS';
export const SET_PAYMENT_ERROR = 'SET_PAYMENT_ERROR';
export const RESET_PAYMENT = 'RESET_PAYMENT';
export const SET_REPEAT_PAYMENT_ERROR = 'SET_REPEAT_PAYMENT_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const setPaymentConfig = (config) => ({
	type: SET_PAYMENT_CONFIG,
	payload: config
});

export const setPaymentResponse = (paymentResponse) => ({
	type: SET_PAYMENT_RESPONSE,
	payload: paymentResponse
});

export const setPaymentDetails = (paymentDetails) => ({
	type: SET_PAYMENT_ADDITIONAL_DETAILS,
	payload: paymentDetails
});

export const setPaymentError = (error) => ({
	type: SET_PAYMENT_ERROR,
	payload: error
});

export const resetPayment = () => ({
	type: RESET_PAYMENT
});

export const clearPaymentErrors = () => ({
	type: CLEAR_ERRORS
});


export const setRepeatPaymentError = (error) => ({
	type: SET_REPEAT_PAYMENT_ERROR,
	payload: error
});



// WEBPACK FOOTER //
// ./actions/AdyenPaymantActions.js